import api from './apiSetup';
import { serialize } from './util';

export const fetchBundles = params => {
  params = {
    ...params,
    related_searches: 1
    // all: true // for testing purposes shows all bundles
  };
  const query = serialize(params);
  return api(`/bundles${query ? `?${query}` : ''}`);
};

export const fetchBundle = bundleId => {
  return api(`/bundles/${bundleId}`);
};

export const fetchAudios = params => {
  const query = serialize(params);
  return api(`/bundle-audios${query ? `?${query}` : ''}`);
};

export default {
  fetchBundles,
  fetchBundle,
  fetchAudios
};
